export default [
    {
        path:'/chat',
        component: resolve => require(['../../../components/layout/Home.vue'], resolve),
        children:[
            {
                path: '',
                component: resolve => require(['./chat.vue'], resolve),
                meta: { title: '聊天管理' }
            }
        ]
    },
    {
        path:'/chatHistory',
        component: resolve => require(['../../../components/layout/Home.vue'], resolve),
        children:[
            {
                path: '',
                component: resolve => require(['./chatHistory.vue'], resolve),
                meta: { title: '聊天记录' }
            }
        ]
    },
    {
        path:'/prescriptions',
        component: resolve => require(['../../../components/layout/Home.vue'], resolve),
        children:[
            {
                path: '',
                component: resolve => require(['./Prescription.vue'], resolve),
                meta: { title: '处方管理' }
            }
        ]
    },
    {
        path:'/order',
        component: resolve => require(['../../../components/layout/Home.vue'], resolve),
        children:[
            {
                path: '',
                component: resolve => require(['./order.vue'], resolve),
                meta: { title: '预约管理' }
            }
        ]
    },
    {
        path:'/orderDetails',
        component: resolve => require(['../../../components/layout/Home.vue'], resolve),
        children:[
            {
                path: '',
                component: resolve => require(['./orderDetails.vue'], resolve),
                meta: { title: '预约详情' }
            }
        ]
    },
]
